export default "/_next/static/images/dcd5162fea7cbc79bcab7415057b4dc2.jpg";